module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.target) ? _c('a', {
    staticClass: "sms-button",
    class: [_vm.type, _vm.buttonSize],
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  }, [_vm._t("default")], 2) : (_vm.link) ? _c('router-link', {
    staticClass: "sms-button",
    class: [_vm.type, _vm.buttonSize],
    attrs: {
      "to": _vm.url
    }
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "sms-button",
    class: [_vm.type, _vm.buttonSize]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6066fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sms_button.vue
// module id = 451
// module chunks = 24